import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../layout/Layout";
import "./ViewContact.css";

const ViewContact = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  const API = "https://data.shreemwell.in/api/contacts";

  useEffect(() => {
    getContact();
  }, []);

  const getContact = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response:", res.data);

      if (res.data.success) {
        setContact(res.data.data);
      }
    } catch (error) {
      console.error(error);
      alert("Failed to load contact");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="loading-container">
          <h2>Loading Contact...</h2>
        </div>
      </Layout>
    );
  }

  if (!contact) {
    return (
      <Layout>
        <div className="loading-container">
          <h2>Contact Not Found</h2>

          <button
            className="back-btn"
            onClick={() => navigate("/contacts")}
          >
            Back
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="view-contact-container">

        <div className="view-header">
          <h2>Contact Details</h2>

          <button
            className="back-btn"
            onClick={() => navigate("/contacts")}
          >
            ← Back
          </button>
        </div>

        <div className="contact-card">

          <div className="profile-section">

            <div className="profile-avatar">
              {(contact.firstName?.charAt(0) || "").toUpperCase()}
              {(contact.lastName?.charAt(0) || "").toUpperCase()}
            </div>

            <h3>
              {contact.firstName} {contact.lastName}
            </h3>

            <span className="contact-level">
              {contact.contactLevel || "N/A"}
            </span>

          </div>

          <div className="details-grid">
            <div className="detail-item">
              <label>Account ID</label>
              <p>
                {contact.accountId?._id
                  ? contact.accountId._id.slice(-4)
                  : "-"}
              </p>
            </div>

            <div className="detail-item">
              <label>First Name</label>
              <p>{contact.firstName || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Last Name</label>
              <p>{contact.lastName || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Nickname</label>
              <p>{contact.nickname || "-"}</p>
            </div>


            <div className="detail-item">
              <label>Date of Birth</label>
              <p>
                {contact.dateOfBirth
                  ? new Date(contact.dateOfBirth).toLocaleDateString()
                  : "-"}
              </p>
            </div>
            <div className="detail-item">
              <label>Mobile</label>
              <p>{contact.mobile || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Alternate Mobile</label>
              <p>{contact.alternateMobile || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Whatsapp Number</label>
              <p>{contact.whatsappNumber || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Email</label>
              <p>{contact.email || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Current Location</label>
              <p>{contact.currentLocation || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Work Location</label>
              <p>{contact.workLocation || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Wish Location</label>
              <p>{contact.whichLocation || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Relationship Level</label>
              <p>{contact.contactLevel || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Relation Type</label>
              <p>{contact.RelationType || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Personal Note</label>
              <p>{contact.personalNote || "-"}</p>
            </div>

            <div className="detail-item">
  <label>Public Note</label>
  <p>{contact.publicNote || "-"}</p>
</div>

            <div className="detail-item">
              <label>Upline</label>
              <p>{contact.upline || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Upline Name</label>
              <p>{contact.uplineName || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Upline Code</label>
              <p>{contact.uplineCode || "-"}</p>
            </div>

            <div className="detail-item">
              <label>SAO Name</label>
              <p>{contact.saoName || "-"}</p>
            </div>

            <div className="detail-item">
              <label>SAO Code</label>
              <p>{contact.saoCode || "-"}</p>
            </div>

            <div className="detail-item">
              <label>SGO Name</label>
              <p>{contact.sgoName || "-"}</p>
            </div>

            <div className="detail-item">
              <label>SGO Code</label>
              <p>{contact.sgoCode || "-"}</p>
            </div>

            <div className="detail-item">
              <label>SSG Name</label>
              <p>{contact.ssgName || "-"}</p>
            </div>

            <div className="detail-item">
              <label>SSG Code</label>
              <p>{contact.ssgCode || "-"}</p>
            </div>

            <div className="detail-item">
              <label>Created At</label>
              <p>
                {contact.createdAt
                  ? new Date(contact.createdAt).toLocaleString()
                  : "-"}
              </p>
            </div>

            <div className="detail-item">
              <label>Updated At</label>
              <p>
                {contact.updatedAt
                  ? new Date(contact.updatedAt).toLocaleString()
                  : "-"}
              </p>
            </div>

          </div>

          <div className="button-group">

            <button
              className="edit-btn"
              onClick={() => navigate(`/edit-contact/${contact._id}`)}
            >
              Edit Contact
            </button>

            <button
              className="back-btn"
              onClick={() => navigate("/ContactMangement")}
            >
              Back
            </button>

          </div>

        </div>

      </div>
    </Layout>
  );
};

export default ViewContact;